import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import sparkle from 'client/images/ai-sparkle-white.svg';

import './ai-link-content.scss';

export const AiLinkContent = memo(({ newLabelClasses = 'bg-white text-purple-10', withSparkle = false }) => {
  return (
    <span className="ai-link-content d-flex justify-content-center align-items-center">
      <span className="ai-copy text-white">AI Assistant</span>
      {withSparkle && <img className="ms-0_25 me-0_5" src={sparkle} width={15} alt="Ask AI" loading="lazy" />}
      <span
        className={classnames(
          'new-label keep-style-in-critical-even-if-not-in-dom fw-bold size-10 rounded-1 d-flex justify-content-center align-items-center',
          newLabelClasses
        )}
      >
        NEW
      </span>
    </span>
  );
});

AiLinkContent.displayName = 'AiLinkContent';
AiLinkContent.propTypes = {
  newLabelClasses: PropTypes.string,
  withSparkle: PropTypes.bool,
};
